import { SlidePromptLayout } from '@pushly/models/lib/enums'
import { PromptPosition } from '@pushly/models/lib/enums/prompts/prompt-position'
import { DeliveryChannel } from '@pushly/aqe/lib/enums/delivery-channels'
import { PromptGroupDisplayCondition } from '@pushly/models/lib/enums/prompts/prompt-group-display-condition'

// Editor
export const DEFAULT_PROMPT_GROUP_CHANNEL = DeliveryChannel.WEB
export const DEFAULT_INPUT_FIELD_DEBOUNCE_MS = 320

// Group Display
export const DEFAULT_DESKTOP_DISPLAY_CONDITION = PromptGroupDisplayCondition.ENABLED
export const DEFAULT_MOBILE_DISPLAY_CONDITION = PromptGroupDisplayCondition.ENABLED

// Visitor Conditions
export const DEFAULT_SESSION_PAGE_VIEWS = 2
export const DEFAULT_SESSION_TIME_ON_SITE_SECONDS = 1
export const DEFAULT_TIME_ON_PAGE_SECONDS = 1
export const DEFAULT_SCROLL_DEPTH = 50

// Behaviors
export const DEFAULT_COOKIE_LENGTH_SECONDS = 7 * 24 * 60 * 60

// Variants
export const VARIANT_NAME_MAX_CHARS = 45

// Slide Theme
export const DEFAULT_LAYOUT = SlidePromptLayout.NORMAL
export const DEFAULT_DESKTOP_POSITION = PromptPosition.TOP
export const DEFAULT_MOBILE_POSITION = PromptPosition.BOTTOM
export const DEFAULT_BACKGROUND_COLOR = '#FFFFFF'
export const DEFAULT_ACCENT_COLOR = '#555'
export const DEFAULT_TITLE_COLOR = '#555'
export const DEFAULT_SUBTITLE_COLOR = '#555'
export const DEFAULT_ALLOW_TEXT = 'Allow'
export const DEFAULT_ALLOW_TEXT_COLOR = DEFAULT_BACKGROUND_COLOR
export const DEFAULT_ALLOW_BUTTON_COLOR = DEFAULT_ACCENT_COLOR
export const DEFAULT_DISMISS_TEXT = 'Dismiss'
export const DEFAULT_DISMISS_TEXT_COLOR = DEFAULT_ACCENT_COLOR
export const DEFAULT_DISMISS_BUTTON_COLOR = DEFAULT_BACKGROUND_COLOR

// Error Field Names Map
export const PromptErrorFieldNamesMap = {
    prompts: '',
    config: '',
    theme: '',
    conditions: '',
    page: '',
    visitor: '',
    behavior: '',
    'prompts.*.id': 'Prompt ID',
    'prompts.0.name': 'Variant 1 Name',
    'prompts.1.name': 'Variant 2 Name',
    'prompts.2.name': 'Variant 3 Name',
    'prompts.3.name': 'Variant 4 Name',
    'prompts.*.name': 'Variant Name',
    'prompts.*.config.behavior.cookieLengthSeconds': 'Prompt dismiss time',
    'prompts.*.conditions.visitor.timeOnPageSeconds': 'Time-on-Page',
    'prompts.*.conditions.visitor.sessionTimeOnSiteSeconds': 'Session Time-on-Site',
    'prompts.*.conditions.visitor.sessionPageViews': 'Session Page Views',
    'prompts.*.conditions.visitor.scrollDepthPct': 'Scroll Depth',
    'prompts.*.config.theme.title.text': 'Title',
    'prompts.*.config.theme.title.textColor': 'Title color',
    'prompts.*.config.theme.subtitle.text': 'Subtitle',
    'prompts.*.config.theme.subtitle.textColor': 'Subtitle color',
    'prompts.*.config.theme.allowButton.text': 'Allow Button text',
    'prompts.*.config.theme.allowButton.textColor': 'Allow Button text color',
    'prompts.*.config.theme.allowButton.backgroundColor': 'Allow Button color',
    'prompts.*.config.theme.dismissButton.text': 'Dismiss Button text',
    'prompts.*.config.theme.dismissButton.textColor': 'Dismiss Button text color',
    'prompts.*.config.theme.dismissButton.backgroundColor': 'Dismiss Button color',
    'prompts.*.config.theme.position.desktop': 'Desktop position',
    'prompts.*.config.theme.position.mobile': 'Mobile position',
    'prompts.*.config.theme.image': 'Image',
    'prompts.*.config.theme.backgroundColor': 'Background color',
}
